import type { RouteObject } from "react-router-dom";
import { PagesAltTextManagerUiDisplay } from "./Display";

export { PagesAltTextManagerUiDisplay };

export const PagesAltTextManagerUiRoutes: RouteObject[] = [
  {
    path: "alt-text-manager",
    element: <PagesAltTextManagerUiDisplay />
  }
];
